import { Button } from '@febos-io/design';

import { useState } from 'react';
import ModalDialog from './ModalDialog';
import { useModalContext } from '../providers';
import useTranslation from '../hooks/useTranslation';

export function ModalConfirm() {
  const [isConfirming, setIsConfirming] = useState(false);
  const { modalPayload, } = useModalContext();
  const {
    title,
    message,
    onConfirm,
    onCancel,
    cancel = false,
  } = modalPayload;

  const {
    t,
  } = useTranslation();

  const handleConfirm = async () => {
    setIsConfirming(true);
    try {
      await onConfirm();
    } finally {
      setIsConfirming(false);
    }
  };

  const handleCancel = async () => {
    await onCancel();
  };

  return (
    <ModalDialog useBackdropClose useCloseModal title={title} className="modal-dialog-centered">
      <div className="modal-body">{message}</div>
      <div className="modal-footer">
        <div className="row">
          <div className="col-12">
            {cancel && (
              <Button onClick={handleCancel} className="btn-danger">
                {t('Cancel')}
              </Button>
            )}
            <Button onClick={handleConfirm} loading={isConfirming}>
              {t('Confirm')}
            </Button>
          </div>
        </div>
      </div>
    </ModalDialog>
  );
}

export default ModalConfirm;
